import { QueryResult } from "@apollo/client/react/types/types";
import { SalaryChangeEffectiveDateEnum, ShortTermDisabilityPolicyCoverage } from "../generated/graphql";
import { AuthContextProps } from "oidc-react";
import { usePolicy } from "./usePolicy";
import { DateTime } from "luxon";
import { WageAsOfDate } from "../component/domain/WageAsOfDate";
import { FederationProduct } from "../component/enums/FederationProduct";

export function useWageAsOfDate(policyId?: string, memberId?: string, effectiveDate?: string, product?: FederationProduct | null, dateLastWorked?: string, auth?: AuthContextProps): QueryResult<{ findWageAsOfDate: WageAsOfDate | null }> {
    const user = auth?.userData;
    const signedIn = !!user;

    const { data: policyData, loading: policyLoading, error: policyError } = usePolicy(policyId, memberId, effectiveDate, auth)
    const defaultResult = { data: { findWageAsOfDate: { wageAsOfDate: dateLastWorked } } } as QueryResult;
    if(!signedIn || policyId?.length !== 7 || memberId?.length !== 9 || !product || !dateLastWorked) {
        return defaultResult;
    }
    const coverage = (policyData?.findPolicy?.memberGroups?.[0]?.coverages as any)?.[product] as ShortTermDisabilityPolicyCoverage;
    const wageAsOfDate = calculateWageAsOfDateFor(dateLastWorked, coverage?.configuration?.salaryChangeEffectiveDate)
    return { data: { findWageAsOfDate: { wageAsOfDate: wageAsOfDate } }, loading: policyLoading, error: policyError } as QueryResult
}

function calculateWageAsOfDateFor(dateLastWorked: string, salaryChangeEffectiveDate?: SalaryChangeEffectiveDateEnum | null) {
    let wageAsOfDate = DateTime.fromFormat(dateLastWorked, 'MM/dd/yyyy');
    if (salaryChangeEffectiveDate === SalaryChangeEffectiveDateEnum.FirstOfCoincidingMonth) {
        wageAsOfDate = wageAsOfDate.startOf('month')
    } else if (salaryChangeEffectiveDate === SalaryChangeEffectiveDateEnum.FifteenthOfCoincidingMonthSlashFollowingMonth) {
        wageAsOfDate = (wageAsOfDate.day <= 14 ? wageAsOfDate.minus({months: 1}) : wageAsOfDate).set({day: 15})
    }
    return wageAsOfDate.toFormat('MM/dd/yyyy')
}